import { z } from 'zod';

import {
  MaintenanceVisitPeriodsListResponse,
  MaintenanceVisitPeriodsListResponseItem,
  MaintenanceVisitPeriodsSummaryRetrieveResponse,
} from '~/data/generated/zod/maintenance-visit-periods/maintenance-visit-periods.zod';

export const maintenanceVisitPeriodListSchema = MaintenanceVisitPeriodsListResponse;

export type MaintenanceVisitPeriod = z.infer<typeof MaintenanceVisitPeriodsListResponseItem>;
export type MaintenanceVisitHistoryEntry = MaintenanceVisitPeriod['history'][number];
export type MaintenanceVisitTicket = MaintenanceVisitPeriod['tickets'][number];

// The summary carries the window to draw as well as the rows, because the rolling
// window's dates are decided server-side.
export const maintenanceVisitSummarySchema = MaintenanceVisitPeriodsSummaryRetrieveResponse;

export type MaintenanceVisitSummaryResponse = z.infer<
  typeof MaintenanceVisitPeriodsSummaryRetrieveResponse
>;
export type MaintenanceVisitCarSummary = MaintenanceVisitSummaryResponse['cars'][number];
export type MaintenanceVisitPeriodCell = MaintenanceVisitCarSummary['periods'][number];
export type MaintenanceVisitWindow = MaintenanceVisitSummaryResponse['window'];
